import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility/utility";

const initialState = {
	message: null,
	resetMessage: null,
	error: null,
	loading: false,
	showResendLink: null,
	isSpinning: false
};

const resetStart = (state, action) => {
	return updateObject(state, {
		error: null,
		loading: true,
		message: null,
		isSpinning: false
	});
};

const clearForgotPassword = (state, action) => {
	return updateObject(state, {
		error: null,
		loading: false,
		message: null,
		resetMessage: null,
		showResendLink: null,
		isSpinning: false
	});
};

const resetSuccess = (state, action) => {
	return updateObject(state, {
		message: action.successMessage,
		showResendLink: null,
		isSpinning: false
	});
};

const resetFail = (state, action) => {
	return updateObject(state, {
		error: action.error.message,
		showResendLink: action.error.showResendLink,
		isSpinning: false
	});
};

const forgotPasswordStart = (state, action) => {
	return updateObject(state, {
		error: null,
		loading: true,
		resetMessage: null
	});
};

const forgotPasswordSuccess = (state, action) => {
	return updateObject(state, {
		resetMessage: action.successMessage,
		message: null,
		error: null,
		showResendLink: null,
		loading: false,
		isSpinning: false
	});
};
const forgotPasswordFail = (state, action) => {
	return updateObject(state, {
		error: action.error.message,
		loading: false,
		showResendLink: action.error.showResendLink,
		isSpinning: false
	});
};

const isSpinning = (state, action) => {
	return updateObject(state, {
		isSpinning: action.response
	});
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.RESET_PASSWORD_START:
			return resetStart(state, action);
		case actionTypes.RESET_PASSWORD_SUCCESS:
			return resetSuccess(state, action);
		case actionTypes.RESET_PASSWORD_FAIL:
			return resetFail(state, action);
		case actionTypes.FORGOT_PASSWORD_START:
			return forgotPasswordStart(state, action);
		case actionTypes.FORGOT_PASSWORD_SUCCESS:
			return forgotPasswordSuccess(state, action);
		case actionTypes.FORGOT_PASSWORD_FAIL:
			return forgotPasswordFail(state, action);
		case actionTypes.CLEAR_FORGOT_PASSWORD:
			return clearForgotPassword(state, action);
		case actionTypes.IS_SPINNING:
			return isSpinning(state, action);
		default:
			return state;
	}
};

export default reducer;
